import { type CSSProperties, type HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export interface StepperStep {
  key: string;
  label: string;
}

export interface StepperProps extends Omit<HTMLAttributes<HTMLOListElement>, "children"> {
  currentStep: string;
  steps: StepperStep[];
}

export function Stepper({ "aria-label": ariaLabel = "Progress", className, currentStep, steps, style, ...props }: StepperProps) {
  const currentIndex = steps.findIndex((step) => step.key === currentStep);
  const stepperStyle = {
    ...style,
    "--stepper-count": Math.max(steps.length, 1)
  } as CSSProperties;

  return (
    <ol className={cn("ui-stepper", className)} aria-label={ariaLabel} style={stepperStyle} {...props}>
      {steps.map((step, index) => {
        const active = step.key === currentStep;
        const complete = currentIndex >= 0 && index < currentIndex;
        return (
          <li
            className={cn(
              "ui-stepper-step",
              active && "ui-stepper-step-active",
              complete && "ui-stepper-step-complete"
            )}
            key={step.key}
            aria-current={active ? "step" : undefined}
          >
            <span className="ui-stepper-marker" aria-hidden="true" />
            <span className="ui-stepper-label">
              <span className="sr-only">Step {index + 1}: </span>
              {step.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
